//import request from "superagent";
//import _ from "lodash";
//import { CognitoUserAttribute } from "amazon-cognito-identity-js";
//import moment from "moment-timezone";

//import env from "../constants/env";
//import * as userActions from "./user";
import state from "../state";
//import { showError } from "./alertActions";
//import { refreshCredentials } from "../utils/securityUtil";
//import { getOrgId } from "./orgsActions";

export function getIdentityId() {
	return state.select(["user", "identityId"]).get();
}

export function getUsername() {
	return state.select(["user", "username"]).get();
}

/*
export function getTimezone() {
	const org = state.get(["selectedOrg"]);
	const tz = _.get(org, "member.timeZone", moment.tz.guess());
	return tz ? tz : moment.tz.guess();
}

export function getJwtToken(credentials = window.credentials) {
	return credentials.params.Logins[env.cognito.loginContext];
}

export function isOrganizationAdministrator() {
	const org = state.get(["selectedOrg"]);
	return _.get(org, "member.administrator", false);
}

export function isOrganizationAuthor() {
	const org = state.get(["selectedOrg"]);
	return _.get(org, "member.author", false);
}

export function getDisplayName() {
	const org = state.get(["selectedOrg"]);
	return _.get(org, "member.displayName", "?");
}
*/
/**
 * Determine the current users role
 * @return<int> 0 - normal user, 1 - author, 2 -administrator
 */
/*
export function getUserRole() {
	let role = 0;

	if (isOrganizationAdministrator()) {
		role = 2;
	} else if (isOrganizationAuthor()) {
		role = 1;
	}

	return role;
}

export function getGroupMemberships() {
	return state.get(["selectedOrg", "member", "groups"]);
}

export function isSelf(member) {
	return state.get(["selectedOrg", "member", "id"]) === member.id;
}

export const SUBSCRIPTION_PLAN_BASIC = "basic-plan";
export function getSubscriptionPlan() {
	return state.get(["user", "subscriptionPlan"]);
}

export function updateAttribute(cognitoUser, name, value) {
	try {
		if (cognitoUser && cognitoUser.updateAttributes) {
			const attributeList = [];
			const params = {
				Name: name,
				Value: _.isString(value) ? value : JSON.stringify(value),
			};
			const attribute = new CognitoUserAttribute(params);
			attributeList.push(attribute);

			cognitoUser.updateAttributes(attributeList, (err, result) => {
				if (err) {
					showError("Failed to update user attributes", err.toString());
					return;
				}
				console.log(`call result: ${result}`);
			});
		}
	} catch (e) {
		alert("Failed to set user attribute " + e);
	}
}

function setMemberProp(prop, value) {
	state.set(["selectedOrg", "member", prop], value);
}

export function setDisplayName(displayName) {
	setMemberProp("displayName", displayName);
}

export function setTimezone(timeZone) {
	setMemberProp("timeZone", timeZone);
}

export function saveChanges() {
	// Save all attributes that are editable

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const orgMember = state.set(["selectedOrg", "member"]);
			// Ok accept it
			request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.editOrgMember(getOrgId())}`)
				.set("Authorization", userActions.getJwtToken())
				.set("Content-Type", "application/json")
				.send(JSON.stringify(orgMember))
				.then(res => {
					resolve(res);
				}).catch(err => {
					reject(err);
				});

		});
	});
}
*/